<template>
  <div class="indexer mb-1" v-if="loaded">
    <drop-down class="mb-1" id="drop-down-resolver-drop-down" label="Specify the role:" v-model="selectedItem"
      :items="items" :value-as-key="false" />
    <div class="d-flex">
      <button class="btn btn-primary" type="button" @click="resolveClicked">
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
import roleIndexer from "@/services/sharedo/roleIndexerService";

export default {
  props: {
    dataContext: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      items: [],
      selectedItem: null,
      loaded: false,
    };
  },
  methods: {
    load: async function () {
      const roles = await roleIndexer.getRoles(this.dataContext);

      this.items = roles.map(role => ({
        label: role.name,
        value: role.systemName
      }));

      this.selectedItem = this.items[0].value;
      this.loaded = true;
    },
    resolveClicked: function () {
      this.$emit("resolve", this.selectedItem);
    },
  },
  mounted: async function () {
    await this.load();
  }
}
</script>